































































































import { Component,  Vue } from 'vue-property-decorator';
@Component
export default class Makieta extends Vue {
    private activeGroup = '';

    isActive(gid: string): boolean {
        return this.activeGroup === gid;
    }

    activeToggle(gid: string): void {
        if (this.activeGroup !== gid) {
            this.activeGroup = gid;
            this.$emit('myChangeActive', {gid: gid});
        }
    }
}
